import React from 'react';
import {FormControl, FormHelperText, InputLabel, Select, SelectProps} from '@mui/material';
import {
   DropdownObjectOption,
   DropdownOptions,
   isDropdownObjectOption,
} from 'components/inputs/Dropdown';
import {readOnlyContext} from 'common/context/ReadOnlyContext';
import {useController, useFormContext} from 'react-hook-form';
import {SetValueOptions} from 'components/hook-form/helpers';
import {useRegisterLabel} from 'common/context/FormContext';

const renderItems = (options: DropdownOptions) => {
   if (!options) {
      return null;
   }
   return options.map((option) => {
      const value = isDropdownObjectOption(option)
         ? (option as DropdownObjectOption).id
         : (option as string);
      const name = isDropdownObjectOption(option)
         ? (option as DropdownObjectOption).name
         : (option as string);
      return (
         <option key={value} value={value}>
            {name}
         </option>
      );
   });
};

type Props = {
   name: string;
   options: DropdownOptions;
   required?: boolean;
   className?: string;
} & SelectProps;
const FormikListBox = (props: Props) => {
   const {className, required, name, options, ...otherProps} = props;
   // const [field, meta] = useField({name, type: 'select'});
   const readOnly = React.useContext(readOnlyContext);
   const labelId = `${props.name}_id`;

   const {
      field,
      fieldState: {error},
   } = useController({
      name,
   });
   useRegisterLabel(name, otherProps.placeholder || (otherProps.label as string));
   const {setValue} = useFormContext();

   const handleChangeMultiple = (event: any) => {
      const {options} = event.target;
      const value: string[] = [];
      for (let i = 0, l = options.length; i < l; i += 1) {
         if (options[i].selected) {
            value.push(options[i].value);
         }
      }
      setValue(name, value, SetValueOptions);
   };

   return (
      <FormControl
         variant="outlined"
         required={required}
         disabled={props.disabled || readOnly}
         className={className}
         fullWidth
      >
         <InputLabel shrink={true} id={labelId}>
            {props.label}
         </InputLabel>
         <Select
            labelId={labelId}
            native
            multiple
            {...field}
            onChange={handleChangeMultiple}
            {...otherProps}
         >
            {renderItems(options)}
         </Select>
         {error?.message ? <FormHelperText>{error.message}</FormHelperText> : null}
      </FormControl>
   );
};

export default React.memo(FormikListBox);
